import { Link, NavLink, useNavigate } from "react-router-dom";

function Top() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("phone");
    navigate("/", { replace: true });
  };

  return (
    <>
      <div
        class="offcanvas offcanvas-bottom m-2 rounded-4 shadow border-0"
        tabindex="-1"
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
      >
        <div className="d-flex align-items-center justify-content-center">
          <div
            className="circle-lg-btn bg-white rounded-circle mt-n8 z-1 position-relative"
            type="button"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="bi bi-x-lg"></i>
          </div>
        </div>
        <div class="offcanvas-body">
          <div className="gradient-top rounded-top-4"></div>
          <div className="mt-2">
            <ul className="p-0 mb-2">
              <button
                className="btn w-100 border-0 text-start rounded-pill d-flex justify-content-between px-2 pe-0 py-0"
                data-bs-dismiss="offcanvas"
                type="button"
                onClick={() => navigate("/dashboard")}
              >
                <div className="text-black menu-font">
                  <i className="bi bi-house me-3"></i>
                  Home
                </div>
                <div className="circle-sm-btn bg-light rounded-circle">
                  <i className="bi bi-chevron-right"></i>
                </div>
              </button>
              <button
                className="btn w-100 border-0 text-start rounded-pill d-flex justify-content-between px-2 pe-0 py-0"
                data-bs-dismiss="offcanvas"
                type="button"
                onClick={() => navigate("/all-events")}
              >
                <div className="menu-font">
                  <i className="bi bi-grid me-3"></i>
                  My / Shared Events
                </div>
                <div className="circle-sm-btn bg-light rounded-circle">
                  <i className="bi bi-chevron-right"></i>
                </div>
              </button>
              <button
                className="btn w-100 border-0 text-start rounded-pill d-flex justify-content-between px-2 pe-0 py-0"
                data-bs-dismiss="offcanvas"
                type="button"
                onClick={() => navigate("/create-event")}
              >
                <div className="menu-font">
                  <i className="bi bi-journals me-3"></i>
                  Create Event
                </div>
                <div className="circle-sm-btn bg-light rounded-circle">
                  <i className="bi bi-chevron-right"></i>
                </div>
              </button>
              <button
                className="btn w-100 border-0 text-start rounded-pill d-flex justify-content-between px-2 pe-0 py-0"
                data-bs-dismiss="offcanvas"
                type="button"
                onClick={() => navigate("/my-photos")}
              >
                <div className="menu-font">
                  <i className="bi bi-images me-3"></i>
                  My Photos
                </div>
                <div className="circle-sm-btn bg-light rounded-circle">
                  <i className="bi bi-chevron-right"></i>
                </div>
              </button>
              <button
                className="btn w-100 border-0 text-start rounded-pill d-flex justify-content-between px-2 pe-0 py-0"
                data-bs-dismiss="offcanvas"
                type="button"
                onClick={() => navigate("/settings")}
              >
                <div className="menu-font">
                  <i className="bi bi-gear me-3"></i>
                  Settings
                </div>
                <div className="circle-sm-btn bg-light rounded-circle">
                  <i className="bi bi-chevron-right"></i>
                </div>
              </button>
              <hr className="mx-2" />
              <button
                className="btn w-100 border-0 text-start rounded-pill d-flex justify-content-between px-2 pe-0 py-0"
                data-bs-dismiss="offcanvas"
                type="button"
                onClick={() => navigate("/pricing")}
              >
                <div className="menu-font">
                  <i className="bi bi-wallet me-3"></i>
                  Pricing
                </div>
                <div className="circle-sm-btn bg-light rounded-circle">
                  <i className="bi bi-chevron-right"></i>
                </div>
              </button>
              <button
                className="btn w-100 border-0 text-start rounded-pill d-flex justify-content-between px-2 pe-0 py-0"
                data-bs-dismiss="offcanvas"
                type="button"
                onClick={() => navigate("/contact")}
              >
                <div className="menu-font">
                  <i className="bi bi-headset me-3"></i>
                  Contact Us
                </div>
                <div className="circle-sm-btn bg-light rounded-circle">
                  <i className="bi bi-chevron-right"></i>
                </div>
              </button>
              <button
                className="btn w-100 border-0 text-start rounded-pill d-flex justify-content-between px-2 pe-0 py-0"
                data-bs-dismiss="offcanvas"
                type="button"
                onClick={() => navigate("/terms")}
              >
                <div className="menu-font">
                  <i className="bi bi-info-circle me-3"></i>
                  Terms & Conditions
                </div>
                <div className="circle-sm-btn bg-light rounded-circle">
                  <i className="bi bi-chevron-right"></i>
                </div>
              </button>
            </ul>
          </div>
          <div className="gradient-bottom rounded-bottom-4"></div>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg py-2 px-0 sticky-top my-header-bg z-5">
        <div className="container">
          <Link to="/">
            <img
              src="/assets/images/logo.png"
              width="130"
              className="me-lg-8"
            />
          </Link>
          <div className="ms-auto d-flex align-items-center order-lg-3">
            <div>
              <div className="d-flex align-items-center">
                <div class="d-flex gap-2 align-items-center justify-content-end me-lg-7 me-5 d-lg-block d-none">
                  <a
                    href="https://www.facebook.com/share/1Ej8ZsML3e/?mibextid=wwXIfr"
                    target="_blank"
                  >
                    <i className="bi bi-facebook text-light fs-4 me-3"></i>
                  </a>
                  <a href="https://www.instagram.com/visualaey" target="_blank">
                    <i className="bi bi-instagram text-light fs-4 me-3"></i>
                  </a>
                  <a href="https://www.x.com/visualaey" target="_blank">
                    <i className="bi bi-twitter-x text-light fs-4"></i>
                  </a>
                </div>
                <Link
                  to="/pricing"
                  className="btn fw-normal btn-gradient-bg-1 shadow-sm me-1 px-4 text-white border-0 rounded-pill"
                >
                  <i className="bi bi-gem me-1"></i> Upgrade
                </Link>

                <Link to="/bin" class="rounded-circle ms-lg-0 ms-2 me-1">
                  <div class="avatar avatar-md avatar-online bg-danger rounded-circle d-flex justify-content-center align-items-center">
                    <span className="cursor-pointer d-flex justify-content-center align-items-center">
                      <i className="bi bi-trash fs-3 text-white"></i>
                    </span>
                  </div>
                </Link>
                <span
                  class="rounded-circle ms-lg-0 ms-2"
                  onClick={handleLogout}
                >
                  <div class="avatar avatar-md avatar-indicators avatar-online bg-light rounded-circle d-flex justify-content-center align-items-center">
                    <span className="cursor-pointer d-flex justify-content-center align-items-center">
                      <i className="bi bi-power fs-3 text-danger"></i>
                    </span>
                  </div>
                </span>

                <div className="d-lg-none d-block">
                  <a
                    data-bs-toggle="offcanvas"
                    href="#offcanvasExample"
                    role="button"
                    aria-controls="offcanvasExample"
                  >
                    <img
                      src="/assets/images/menu.png"
                      className="ms-3"
                      width="25"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="collapse navbar-collapse" id="navbar-default">
            <ul className="navbar-nav  mt-3 mt-lg-0">
              <li className="nav-item">
                <NavLink to="/dashboard" className="nav-link ps-0">
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/all-events" className="nav-link">
                  My / Shared Events
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/create-event" className="nav-link">
                  Create Event
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/my-photos" className="nav-link">
                  My Photos
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/payments" className="nav-link">
                  Payments
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/settings" className="nav-link">
                  Settings
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Top;
